import { Link } from 'react-router-dom';

import { NewButton } from '../index';
import { tracking } from '../../../../utils/tracking';
import styles from "./RegisterCards.module.css";

export const RegisterCards = () => {

   const cards = [
      {
         title: 'INNOVATIVE TECHNOLOGIES',
         content1: 'An exclusive group of startups will be selected to showcase their technology, innovation, and products.',
         content2: 'All presenters are pre-vetted and will put their groundbreaking, innovative, and up-and-coming technology startups on display.',
         img: '/assets/events/etvs23/registor-card-img-3.png',
         btnTxt: 'APPLY TO PRESENT',
         btnLink: '/events/etvs23/startups',
         btnColor: '#CF1B5B',
         btnId: 275
      },
      {
         title: 'EXCLUSIVE NETWORKING',
         content1: 'Make connections using the matchmaking platform or at the networking area.',
         content2: 'Connect with and join the ever-growing group of active investors, C-level executives, corporate development professionals, press, and the visionary entrepreneurs that make our events a recurring yearly experience for many.',
         img: '/assets/events/etvs23/registor-card-img-1.png',
         btnTxt: 'GET YOUR TICKET',
         btnLink: '/events/etvs23/registration',
         btnColor: '#CF1B5B',
         btnId: 276
      },
      {
         title: 'INSIGHTFUL CONTENT',
         content1: 'We’re bringing together a fantastic group of top-tier speakers  to illuminate the issues facing us, debate what’s next for technology, and to educate about a wide variety of subjects.',
         content2: 'You’ll hear from Investors, Corporate VCs, Angels, and Seed stage investors, corporate development officers, and tech leaders.',
         img: '/assets/events/etvs23/registor-card-img-2.png',
         btnTxt: 'APPLY TO SPEAK',
         btnLink: '/events/etvs23/speakers',
         btnColor: '#CF1B5B',
         btnId: 277
      },
   ];
   return (
      <div className={styles.registerCards}>
         <h1>SUBERB OFFERINGS</h1>
         <div className={styles.cardsContainer}>
            {
               cards.map((card, i) =>
                  <div key={i} className={styles.card}>
                     <img src={card.img} alt="" />
                     <h4>{card.title}</h4>
                     <p>{card.content1}</p>
                     <p>{card.content2}</p>
                     {/* <Link to={card.btnLink} onClick={() => tracking(card.btnId)}>
                        <NewButton name={card.btnTxt} color={'white'} bgColor={card.btnColor} />
                     </Link> */}
                     <a href="https://youngstartup.com/upcoming" onClick={() => tracking(card.btnId)}>
                        <NewButton name={card.btnTxt} color={'white'} bgColor={card.btnColor} />
                     </a>
                  </div>
               )
            }
         </div>
      </div>
   );
};
